import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BzSwitchComponent } from './switch.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    BzSwitchComponent
  ],
  exports: [
    BzSwitchComponent
  ]
})
export class BzSwitchModule { }
